import React from "react"
import { Col, Image, Row } from "antd"
import { PrismicDocument, FilledImageFieldImage } from "@prismicio/types"
import styled from "@emotion/styled"
import { SearchOutlined } from "@ant-design/icons"

export const mapGalleryImagesForDocument = (d: PrismicDocument<any>) =>
  (d.data?.["photo_gallery"]?.data?.images || []).map((g) => g.image) as FilledImageFieldImage[]

export const PhotoGallery: React.FC<Props> = ({ document, photoGalleryImages, children }) => {
  let images: FilledImageFieldImage[] = []

  if (document) {
    images = mapGalleryImagesForDocument(document)
  } else {
    images = photoGalleryImages
  }

  if (images.length === 0) {
    return null
  }

  return (
    <PhotoGalleryWrapper>
      {children || null}

      <ImagesRow>
        <Image.PreviewGroup>
          {images.map(({ url, alt, dimensions, copyright }, index) => (
            <Col key={`image${index}`} xs={8} sm={8} md={6} lg={6}>
              <Square>
                <Image
                  alt={alt?.length > 0 ? alt : `${index}-gallery-image`}
                  src={url}
                  preview={{
                    mask: <SearchOutlined style={{ fontSize: 42 }} />
                  }}
                />
              </Square>
            </Col>
          ))}
        </Image.PreviewGroup>
      </ImagesRow>
    </PhotoGalleryWrapper>
  )
}

interface Props {
  children?: React.ReactNode
  document?: PrismicDocument<any>
  photoGalleryImages?: FilledImageFieldImage[]
}

const PhotoGalleryWrapper = styled.div`
  margin-top: 0;
`

const ImagesRow = styled(Row)`
  .ant-col {
    padding: 5px;
  }
`

const Square = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100%; /* 1:1 Aspect Ratio */
  overflow: hidden;
  border-radius: 20px;

  .ant-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;

    .ant-image-img {
      height: 100%;
      object-fit: cover;
    }
  }
`
